import { render, staticRenderFns } from "./ProductOptions.vue?vue&type=template&id=33873671"
import script from "./ProductOptions.vue?vue&type=script&lang=ts"
export * from "./ProductOptions.vue?vue&type=script&lang=ts"
import style0 from "./ProductOptions.vue?vue&type=style&index=0&id=33873671&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports